module.exports = __webpack_public_path__ + "img/hexagon1.bcba6943.png";